import { useQuery } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

export interface AvailableBatch {
  batch_name: string;
  batch_code: string;
  coach_name: string;
  class_timing: string; // Comma-separated times
  class_days: string; // Comma-separated days
  start_date: string;
  tournament_id: number;
  level_name: string | null;
}

export interface AvailableBatchesResponse {
  batches: AvailableBatch[];
  tournament_id: number;
  min_start_date: string;
  current_coach_name?: string | null; // Current coach name from user's subscription (if available)
}

export default function useGetAvailableSmallGroupBatches(
  tournamentId: number | undefined,
  planExpiryDate?: string,
  enabled: boolean = true,
) {
  return useQuery<AvailableBatchesResponse>(
    ['available-small-group-batches', tournamentId, planExpiryDate],
    async () => {
      if (!tournamentId) {
        throw new Error('Tournament ID is required');
      }

      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const params = new URLSearchParams({
        tournament_id: tournamentId.toString(),
      });

      if (planExpiryDate) {
        params.append('plan_expiry_date', planExpiryDate);
      }

      const response = await ChessRestClient.get<AvailableBatchesResponse>(
        `subscription/v1/get-available-small-group-batches/?${params.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled: enabled && !!tournamentId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}

